// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { OrderComplaintModel } from "@store/Framework/Types/ApiModels";

export interface AddOrderComplaintApiParameter extends ApiParameter {
    orderComplaintModel: OrderComplaintModel;
}

export async function addOrderComplaint(
    parameter: AddOrderComplaintApiParameter,
): Promise<ServiceResult<OrderComplaintModel>> {
    try {
        const orderComplaintModel = await post<OrderComplaintModel>(
            `api/v1/custom/claimsanddisputes/sendnotification`,
            parameter.orderComplaintModel,
        );
        return {
            successful: true,
            result: orderComplaintModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
